
<div class="cp-share mobile" @click="handleClose">
  <div class="text">
    还可以召集<span class="times">{{userInfo.weixin_state ? userInfo.invitablenum : 4}}</span>名兄弟
  </div>
</div>
